var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "일감연계",
            "tabActive": "동고리 가입방법",
            "bg": "/images/sub/sub-visual6.webp"
          },
          scopedSlots: _vm._u([{
            key: "tit",
            fn: function () {
              return [_vm._v("일감연계")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("동고리 가입방법")];
      },
      proxy: true
    }])
  }, [_c('ul', {
    staticClass: "signup-steps"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      staticClass: "signup-steps__row",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "auto"
      }
    }, [_c('v-card', {
      staticClass: "signup-steps__title",
      attrs: {
        "flat": "",
        "tile": "",
        "min-width": "225"
      }
    }, [_c('v-chip', {
      attrs: {
        "color": "primary",
        "outlined": ""
      }
    }, [_c('txt-primary', {
      staticClass: "txt--lg font-weight-bold primary--text line-height-11"
    }, [_vm._v("STEP " + _vm._s(index + 1))])], 1), _c('u-tit-default', {
      staticClass: "tit--sm"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])], 1)], 1), _c('v-col', [_c('v-card', {
      staticClass: "signup-steps__content",
      attrs: {
        "flat": "",
        "tile": ""
      }
    }, [_c('v-row', {
      staticClass: "row--sm",
      attrs: {
        "align": "center"
      }
    }, [item.steps ? _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('txt-primary', {
      staticClass: "txt--xl txt--dark"
    }, [_c('v-row', {
      staticClass: "ma-n4px ma-lg-n5px",
      attrs: {
        "align": "center"
      }
    }, [_vm._l(item.steps, function (step, index) {
      return [index != 0 ? _c('v-col', {
        key: index,
        staticClass: "d-none d-lg-block pa-lg-5px",
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-avatar', {
        staticClass: "d-flex",
        attrs: {
          "color": "primary",
          "size": "16"
        }
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "white"
        }
      }, [_vm._v("mdi-chevron-right")])], 1)], 1) : _vm._e(), _c('v-col', {
        key: index,
        staticClass: "pa-4px pa-lg-5px",
        attrs: {
          "cols": "12",
          "lg": "auto"
        }
      }, [_c('v-row', {
        attrs: {
          "align": "center",
          "no-gutters": ""
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-sheet', {
        staticClass: "step-number"
      }, [_vm._v(_vm._s(index + 1))]), _c('span', {
        staticClass: "d-none d-lg-inline-block"
      }, [_vm._v(". ")])], 1), _c('v-col', [_vm._v(_vm._s(step))])], 1)], 1)];
    })], 2)], 1)], 1) : _vm._e(), item.guide ? _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('u-tit-default', {
      staticClass: "tit--sm"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.guide)
      }
    })])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      class: ['image-wrap', {
        'image-wrap--sm': item.image.small
      }],
      attrs: {
        "color": "grey-lighten-3",
        "outlined": "",
        "tile": ""
      }
    }, [_c('div', [item.image.title ? _c('u-tit-default', {
      staticClass: "tit--sm text-center font-weight-regular mb-2 mb-md-4"
    }, [_vm._v(" " + _vm._s(item.image.title) + " ")]) : _vm._e(), item.image.children ? [_c('v-carousel', {
      staticClass: "d-lg-none",
      attrs: {
        "hide-delimiters": "",
        "progress": "",
        "progress-color": "primary"
      }
    }, _vm._l(item.image.children, function (child, index) {
      return _c('v-carousel-item', {
        key: index,
        attrs: {
          "src": child,
          "alt": "",
          "eager": ""
        }
      });
    }), 1), _c('v-row', {
      staticClass: "d-none d-lg-flex"
    }, _vm._l(item.image.children, function (child, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "3"
        }
      }, [_c('img', {
        staticClass: "d-block",
        attrs: {
          "src": child,
          "alt": ""
        }
      })]);
    }), 1)] : _c('img', {
      attrs: {
        "src": item.image.src,
        "alt": ""
      }
    })], 2)])], 1)], 1)], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }